package com.vamvisions.main.core.presentation.navigation

import com.vamvisions.main.core.domain.preferences.Language

object RouteParser {

    private const val PORTFOLIO = "/portfolio"
    private const val PROJECTS = "/projects"
    private const val CONTACT = "/contact"

    /**
     * Maps a URL path to its [Route]. A trailing slash, a hash and a query are ignored. A project document path is
     * `/projects/{slug}-{lang}`, where `{lang}` is the last hyphen-separated segment.
     */
    fun parse(path: String): Route {
        val normalized = path.substringBefore('#').substringBefore('?').trimEnd('/').ifEmpty { "/" }
        return when {
            normalized == "/" -> Route.Home
            normalized == PORTFOLIO -> Route.Portfolio
            normalized == PROJECTS -> Route.Projects
            normalized == CONTACT -> Route.Contact
            normalized.startsWith("$PROJECTS/") -> parseProjectDocument(normalized.removePrefix("$PROJECTS/"))
            else -> null
        } ?: Route.NotFound(path)
    }

    private fun parseProjectDocument(segment: String): Route? {
        if ('/' in segment) return null
        val slug = segment.substringBeforeLast('-', missingDelimiterValue = "")
        val language = Language.fromCode(segment.substringAfterLast('-'))
        if (slug.isEmpty() || language == null) return null
        return Route.ProjectDocument(slug, language)
    }
}

fun Route.toPath(): String = when (this) {
    Route.Home -> "/"
    Route.Portfolio -> "/portfolio"
    Route.Projects -> "/projects"
    Route.Contact -> "/contact"
    is Route.ProjectDocument -> "/projects/$slug-${language.code}"
    is Route.NotFound -> path
}
